<template>
    <div class="audit_edit_pf pl10 mt20">

        <!--入驻进展区域-->
        <div class="mt20 mb20" v-if="control.schedule">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">审核进展：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content"><span class="main_word">{{ control.schedule }}</span></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content" v-if="control.content">
                    ({{control.content}})</div></el-col>
            </el-row>
        </div>

        <span class="dib">基础信息</span><span class="line"></span>
        <!--视图编辑区域-->
        <div class="mt20" v-show="control.view == 1">
            <el-form :model="basicForm" :rules="rules" ref="basicForm" class="demo-ruleForm">
                <!-- 供应商基础信息 start -->
                <el-form-item label="供应商编码" prop="suppliersCode" label-width="207px">
                    <el-input class="w500" :disabled="true" v-model="basicForm.suppliersCode" placeholder="请输入供应商编码"></el-input>
                </el-form-item>

                <el-form-item label="供应商名称" prop="suppliersName" label-width="207px">
                    <el-input class="w500" v-model="basicForm.suppliersName" placeholder="请输入供应商名称"></el-input>
                </el-form-item>

                <el-form-item label="办公地址" class="dib" label-width="207px">
                    <span class="main_word rule_star vtb">*</span>
                    <el-select class="ml_10" v-model="basicForm.officeCountry" placeholder="请选择国家" @change="getOfficeProvince">
                        <el-option v-for="val in countryList" :label="val.name" :value="val.id"
                                   :key="val.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="sign_address dib " label-width="0px">
                    <el-select :disabled="isForeign" v-model="basicForm.officeProvince" placeholder="请选择省份"
                               @change="getOfficeCity">
                        <el-option v-for="val in provinceList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="dib sign" label-width="0px">
                    <el-select :disabled="isForeign" v-model="basicForm.officeCity" placeholder="请选择城市"
                               @change="getOfficeDistrict">
                        <el-option v-for="val in cityList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="dib sign" label-width="0px">
                    <el-select :disabled="isForeign" v-model="basicForm.officeDistrict" placeholder="请选择区县">
                        <el-option v-for="val in districtList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="officeAddress" label-width="207px">
                    <el-input class="w500" :autosize="{ minRows: 4, maxRows: 6}" type="textarea"
                              v-model="basicForm.officeAddress" placeholder="请输入您的详细地址"></el-input>
                </el-form-item>

                <!-- 供应商资质信息 start -->
                <span class="mb20">供应商资质信息</span><span class="second_line"></span>

                <el-form-item label="注册登记名称：" prop="registeredName" label-width="207px">
                    <el-input class="w500" v-model="basicForm.registeredName" placeholder="请输入注册登记名称"></el-input>
                </el-form-item>

                <el-form-item label="注册登记地址：" class="dib" prop="registeredCountry" label-width="207px">
                    <el-select v-model="basicForm.registeredCountry" placeholder="请选择国家"
                               @change="getRegisteredProvince">
                        <el-option v-for="val in countryList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="dib sign" label-width="0px">
                    <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredProvince"
                               placeholder="请选择省份" @change="getRegisteredCity">
                        <el-option v-for="val in registeredProvinceList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="dib sign" label-width="0px">
                    <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredCity" placeholder="请选择城市"
                               @change="getRegisteredDistrict">
                        <el-option v-for="val in registeredCityList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="dib sign" label-width="0px">
                    <el-select :disabled="isRegisteredForeign" v-model="basicForm.registeredDistrict"
                               placeholder="请选择区县">
                        <el-option v-for="val in registeredDistrictList" :label="val.name" :value="val.id"
                                   :key="val.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="registeredAddress" label-width="207px">
                    <el-input class="w500" :autosize="{ minRows: 4, maxRows: 6}" type="textarea"
                              v-model="basicForm.registeredAddress" placeholder="请输入您的详细地址"></el-input>
                </el-form-item>

                <el-form-item label="品类合作类型：" label-width="207px">
                    <span class="main_word rule_star123 vtb">*</span>
                    <el-checkbox-group class="dib vtb ml_10" v-model="categoryType">
                        <el-checkbox label="1" :disabled="isRegisteredForeign">图书类</el-checkbox>
                        <el-checkbox label="2">非图书类</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item v-show="isBook" label="出版社经营许可证电子版：" class="dib" label-width="207px">
                    <span class="main_word rule_star3">*</span>
                    <span class="f666 f12">复印件需加盖公司红章扫描上传</span>
                    <template v-show="!publicationBusinessLicenseShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0"
                                   name="pic"
                                   :file-list="basicForm.publicationBusinessLicenseFile"
                                   list-type="picture-card"
                                   :on-preview="handlePictureCardPreview"
                                   :on-remove="removePublicationLicense"
                                   :before-upload="beforeUpload"
                                   :on-success="handlePublicationLicense">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>

                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="publicationBusinessLicenseShow" class="pic_tip">请上传图片</p>
                </el-form-item>

                <el-form-item label="注册资金：" prop="registeredCapital"  label-width="207px">

                    <el-input class="w500" v-model.number="basicForm.registeredCapital"
                              placeholder="请输入注册资金":maxlength="9"></el-input>（单位：万）
                    <el-radio-group v-model="basicForm.registeredCapitalType">
                        <el-radio :label="1"><span class="f14 f666">人民币</span></el-radio>
                        <el-radio :label="2"><span class="f14 f666">美元</span></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="执照类型：" v-show="basicForm.licenseType !=3" label-width="207px">
                    <el-radio-group v-model="basicForm.licenseType" @change="licenseChange">
                        <el-radio :label="1"><span class="f14 f666">普通营业执照</span></el-radio>
                        <el-radio :label="2"><span class="f14 f666">三证合一／五证合一</span></el-radio>
                        <el-radio v-show="false" :label="3"><span class="f14 f666">国外</span></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="营业执照号：" prop="businessLicenseCode" label-width="207px"
                              :rules="
                              [{ required: true, message: '营业执照号不能为空', trigger: 'blur'}]
                                ">
                    <el-input class="w500" v-model="basicForm.businessLicenseCode"
                              placeholder="请输入营业执照号"></el-input>
                </el-form-item>

                <!-- 营业执照电子版 -->
                <el-form-item label="营业执照电子版：" class="mt20" label-width="207px">
                    <span class="main_word rule_star4">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <template v-show="!businessLicenseShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.businessLicenseFile"
                                   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeBusinessLicense"
                                   :on-success="handleBusinessLicense" :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="businessLicenseShow" class="pic_tip">请上传图片</p>
                </el-form-item>

                <!-- 执照有限期 -->
                <el-form-item v-show="basicForm.registeredCountry == 1" label="执照有效期：" label-width="207px">
                    <span class="main_word rule_star105">*</span>
                    <el-date-picker class="ml_10" v-model="businessLicenseDate" type="daterange"
                                    placeholder="选择执照有效期">
                    </el-date-picker>
                </el-form-item>

                <!-- 组织机构代码 -->
                <el-form-item v-show="isOneCertificate" label="组织机构代码：" label-width="207px">
                    <span class="main_word rule_star2 vtb">*</span>
                    <el-input class="w500 ml_10" v-model="basicForm.orgCode" placeholder="请输入组织机构代码"></el-input>
                </el-form-item>

                <!-- 组织结构代码电子版 -->
                <el-form-item v-show="isOneCertificate" label="组织结构代码电子版：" class="mt20" label-width="207px">
                    <span class="main_word rule_star5">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <template v-show="!orgCodeShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.orgCodeFile"
                                   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeOrgCode"
                                   :on-success="handleOrgCode" :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="orgCodeShow" class="pic_tip">请上传图片</p>
                </el-form-item>

                <!-- 税务登记证电子版 -->
                <el-form-item v-show="isOneCertificate" label="税务登记证电子版：" class="mt20" label-width="207px">
                    <span class="main_word rule_star6">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <template v-if="!taxFileShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.taxFile"
                                   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeTaxFile"
                                   :on-success="handleTaxFile" :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>
                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="taxFileShow" class="pic_tip">请上传图片</p>
                </el-form-item>

                <!-- 开户许可证电子版 -->
                <el-form-item label="开户许可证电子版：" class="mt20" label-width="207px">
                    <span class="main_word rule_star6">*</span>
                    <span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
                    <template v-show="!accountOpeningPermitShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.accountOpeningPermitFile"
                                   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removeAccountOpeningPermit"
                                   :on-success="handleAccountOpeningPermit" :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>

                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="accountOpeningPermitShow" class="pic_tip">请上传图片</p>
                </el-form-item>
                <!-- 法定代表人证件类型 -->
                <el-form-item label="法定代表人证件类型：" class="mt20" label-width="207px">
                    <span class="main_word rule_star5">*</span>
                    <el-radio-group class="ml_10" v-model="basicForm.personalCardType">
                        <el-radio :label="1"><span class="f14 f666">身份证</span></el-radio>
                        <el-radio :label="2"><span class="f14 f666">护照</span></el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 法定代表人身份证件电子版 -->
                <el-form-item label="法定代表人身份证件电子版：" class="dib mt20" label-width="207px">
                    <span class="main_word rule_star200">*</span>
                    <span class="f666 f12 ml_10">身份证正反两面，同一张A4纸，复印件请加盖公司红章</span>
                    <template v-show="!personalCardShow">
                        <div class="fixeds"></div>
                    </template>
                    <template>
                        <el-upload action="/suppliers/uploadImages?biz=0" name="pic" :file-list="basicForm.personalCardFile"
                                   list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="removePersonalCard"
                                   :on-success="handlePersonalCard" :before-upload="beforeUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </template>

                    <span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M</span>
                    <p v-show="personalCardShow" class="pic_tip">请上传图片</p>
                </el-form-item>

                <el-form-item class="mt50 mb50" style="margin-left: 300px">
                    <el-button type="primary" class="mr10" @click="returnPage">返回</el-button>
                    <el-button type="primary" class="mr10" @click="saveForm">暂存</el-button>
                    <el-button type="primary" class="mr10" @click="confirmSubmit('basicForm')">{{control.status == 4 ? '重新提交' : '提交'}}</el-button>
                </el-form-item>
            </el-form>
        </div>


        <!--视图查看区域-->
        <div class="mt20" v-show="control.view == 0">
            <el-form label-width="207px" class="demo-ruleForm">
                <!-- 基础信息 -->
                <el-form-item label="供应商编号：">
                    <div>
                        <span>{{ basicForm.suppliersCode }}</span>
                    </div>
                </el-form-item>

                <el-form-item label="供应商名称：">
                    <div>
                        <span>{{ basicForm.suppliersName }}</span>
                        <span class="main_word" v-if="control.compare == 1 && oldBasicData.suppliersName">{{ oldBasicData.suppliersName }}</span>
                    </div>
                </el-form-item>

                <el-form-item label="办公地址：">
                    <div>
                        <span>{{ basicForm.officeCountryName }}</span>
                        <span>{{ basicForm.officeProvinceName }}</span>
                        <span>{{ basicForm.officeCityName }}</span>
                        <span>{{ basicForm.officeDistrictName }}</span>
                        <span>{{ basicForm.officeAddress }}</span>
                    </div>
                    <div v-if="control.compare == 1">
                        <span class="main_word" v-if="oldBasicData.officeCountryName">{{ oldBasicData.officeCountryName }}</span>
                        <span class="main_word" v-if="oldBasicData.officeProvinceName">{{ oldBasicData.officeProvinceName }}</span>
                        <span class="main_word" v-if="oldBasicData.officeCityName">{{ oldBasicData.officeCityName }}</span>
                        <span class="main_word" v-if="oldBasicData.officeDistrictName">{{ oldBasicData.officeDistrictName }}</span>
                        <span class="main_word" v-if="oldBasicData.officeAddress">{{ oldBasicData.officeAddress }}</span>
                    </div>
                </el-form-item>

                <!-- 供应商资质信息 -->
                <span class="dib">供应商资质信息</span><span class="second_line"></span>
                <span class="main_word mr4"></span>
                <!-- 注册登记地址 -->
                <el-form-item v-if="basicForm.categoryIsBook != 1" label="公司注册地址：" class="dib">
                    <div>
                        <span>{{ basicForm.registeredCountryName }}</span>
                        <span>{{ basicForm.registeredProvinceName }}</span>
                        <span>{{ basicForm.registeredCityName }}</span>
                        <span>{{ basicForm.registeredDistrictName }}</span>
                        <span>{{ basicForm.registeredAddress }}</span>
                    </div>
                    <div v-if="control.compare == 1">
                        <span class="main_word" v-if="oldBasicData.registeredCountryName">{{ oldBasicData.registeredCountryName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredProvinceName">{{ oldBasicData.registeredProvinceName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredCityName">{{ oldBasicData.registeredCityName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredDistrictName">{{ oldBasicData.registeredDistrictName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredAddress">{{ oldBasicData.registeredAddress }}</span>
                    </div>
                </el-form-item>

                <!-- 注册登记名称 -->
                <el-form-item label="注册登记名称：">
                    <span>{{ basicForm.registeredName }}</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.registeredName">&nbsp;&nbsp; {{ oldBasicData.registeredName }}</span>
                </el-form-item>

                <!-- 注册登记地址 -->
                <el-form-item v-if="basicForm.categoryIsBook == 1" label="公司注册地址：" class="dib">
                    <div>
                        <span>{{ basicForm.registeredCountryName }}</span>
                        <span>{{ basicForm.registeredProvinceName }}</span>
                        <span>{{ basicForm.registeredCityName }}</span>
                        <span>{{ basicForm.registeredDistrictName }}</span>
                        <span>{{ basicForm.registeredAddress }}</span>
                    </div>
                    <div v-if="control.compare == 1">
                        <span class="main_word" v-if="oldBasicData.registeredCountryName">{{ oldBasicData.registeredCountryName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredProvinceName">{{ oldBasicData.registeredProvinceName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredCityName">{{ oldBasicData.registeredCityName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredDistrictName">{{ oldBasicData.registeredDistrictName }}</span>
                        <span class="main_word" v-if="oldBasicData.registeredAddress">{{ oldBasicData.registeredAddress }}</span>
                    </div>
                </el-form-item>


                <el-form-item label="品类合作类型：">
                    <el-checkbox-group class="dib vtb ml_10" v-model="categoryType">
                        <el-checkbox label="1" disabled>图书类</el-checkbox>
                        <el-checkbox label="2" disabled>非图书类</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <!-- 出版社经营许可证电子版 -->
                <el-form-item v-if="basicForm.categoryIsBook ==1" label="出版社经营许可证电子版：" class="dib">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.publicationBusinessLicenseFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.publicationBusinessLicenseFile" class="pic_skan_red" v-for="gtFile in oldBasicData.publicationBusinessLicenseFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <!-- 注册资金 -->
                <el-form-item label="注册资金：">
                    <span>{{ basicForm.registeredCapital }}（单位：万）</span>
                    <span v-if="basicForm.registeredCapitalType == 1">人民币</span>
                    <span v-if="basicForm.registeredCapitalType == 2">美元</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.registeredCapital">{{ oldBasicData.registeredCapital }}（单位：万）</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.registeredCapital">人民币</span>
                    <span class="main_word" v-if="control.compare == 2 && oldBasicData.registeredCapital">美元</span>
                </el-form-item>

                <!-- 执照类型 -->
                <el-form-item label="执照类型："  v-show="basicForm.licenseType !=3 ">
                    <span v-if="basicForm.licenseType == 1">普通营业执照</span>
                    <span v-if="basicForm.licenseType == 2">三证合一／五证合一</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.licenseType == 1">普通营业执照</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.licenseType == 2">三证合一／五证合一</span>
                </el-form-item>

                <!-- 营业执照号 -->
                <el-form-item label="营业执照号：">
                    <span>{{ basicForm.businessLicenseCode }}</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.businessLicenseCode">{{ oldBasicData.businessLicenseCode }}</span>
                </el-form-item>

                <!-- 营业执照电子版 -->
                <el-form-item label="营业执照电子版：">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.businessLicenseFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.businessLicenseFile" class="pic_skan_red" v-for="gtFile in oldBasicData.businessLicenseFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <!-- 执照有限期 -->
                <el-form-item v-show="basicForm.registeredCountry == 1" label="执照有效期：">
                    <span>{{ getTimeStr(basicForm.businessLicenseStartDate)}}</span> --
                    <span>{{ getTimeStr(basicForm.businessLicenseEndDate)}}</span>
                    <span class="main_word" v-if="(control.compare == 1) && (oldBasicData.businessLicenseStartDate)">
                        {{ getTimeStr(oldBasicData.businessLicenseStartDate)}} --
                    </span>
                    <span class="main_word" v-if="control.compare == 1 && (oldBasicData.businessLicenseEndDate)">{{ getTimeStr(oldBasicData.businessLicenseEndDate)}}</span>
                </el-form-item>

                <!-- 组织机构代码 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="组织机构代码：">
                    <span>{{ basicForm.orgCode }}</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.orgCode">{{ oldBasicData.orgCode }}</span>
                </el-form-item>

                <!-- 组织结构代码电子版 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="组织结构代码电子版：">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.orgCodeFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.orgCodeFile.length" class="pic_skan_red" v-for="gtFile in oldBasicData.orgCodeFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <!-- 税务登记证电子版 -->
                <el-form-item v-if="basicForm.licenseType == 1" label="税务登记证电子版：" >
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.taxFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.taxFile" class="pic_skan_red" v-for="gtFile in oldBasicData.taxFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <!-- 开户许可证电子版 -->
                <el-form-item label="开户许可证电子版：">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.accountOpeningPermitFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.accountOpeningPermitFile.length > 1" class="pic_skan_red" v-for="gtFile in oldBasicData.accountOpeningPermitFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <!-- 法定代表人证件类型 -->
                <el-form-item label="法定代表人证件类型：">
                    <span v-if="basicForm.personalCardType == 1">身份证</span>
                    <span v-if="basicForm.personalCardType == 2">护照</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.personalCardType == 1">身份证</span>
                    <span class="main_word" v-if="control.compare == 1 && oldBasicData.personalCardType == 2">护照</span>
                </el-form-item>

                <!-- 法定代表人身份证件电子版 -->
                <el-form-item label="法定代表人身份证件电子版：">
                    <div>
                        <img @click="previewPic($event)" class="pic_skan" v-for="gtFile in basicForm.personalCardFile" :src="gtFile.url">
                        <img @click="previewPic($event)" v-if="control.compare == 1 && oldBasicData.personalCardFile" class="pic_skan_red" v-for="gtFile in oldBasicData.personalCardFile" :src="gtFile.url">
                    </div>
                </el-form-item>

                <el-form-item class="mt50 mb50" style="margin-left: 300px">
                    <el-button type="primary" class="mr10" @click="returnPage">返回</el-button>
                    <el-button type="primary" class="mr10" v-if="control.audit == 1" @click="auditForm(0)">审核通过</el-button>
                    <el-button type="primary" class="mr10" v-if="control.audit == 1" @click="auditForm(1)">审核驳回</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--预览图片弹框-->
        <el-dialog :visible.sync="dialogVisible" size="small">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('手机号不能为空'));
                } else {
                    if (/^1[0-9]\d{9}$/.test(value) == false) {
                        callback(new Error('手机号格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                categoryType: [],                               // 品类合作类型

                recordId: 0,                                    // 履历id
                suppliersId: 0,                                  // 供应商id

                control:{
                    loginType:0,
                    status:0,
                    view:0,
                    audit:0,
                    compare:0,
                    schedule:'',
                    content:''
                },

                publicationBusinessLicenseShow: false,          // 是否显示出版社经营许可证电子版
                businessLicenseShow: false,                     // 是否显示营业执照号
                orgCodeShow: false,                             // 是否显示组织机构代码
                taxFileShow: false,                             // 是否显示开户许可证
                accountOpeningPermitShow: false,                // 是否显示开户许可证
                personalCardShow: false,                        // 是否显示法定代表人身份证件

                officeAddressLoad: false,                      // 是否主动加载办公地址
                registeredAddressLoad: false,                  // 是否主动加载注册地址
                countryList: [],                                // 国家地址列表

                provinceList: [],                               // 省份地址列表
                cityList: [],                                   // 城市地址列表
                districtList: [],                               // 区县列表

                registeredProvinceList: [],                     // 注册 省份地址列表
                registeredCityList: [],                         // 注册 城市地址列表
                registeredDistrictList: [],                     // 注册 区县列表

                officeProvinceInit: false,
                officeCityInit: false,
                officeDistrictInit: false,

                registeredProvinceInit: false,
                registeredCityInit: false,
                registeredDistrictInit: false,

                isForeign: false,                               // 办公地址是否是国外
                isBook: false,                                  // 品类是否是图书
                isRegisteredForeign: false,                     // 注册 办公地址是否是国外
                isOneCertificate: true,                         // 是否是三证合一/五证合一
                businessLicenseDate: '',                        // 执照有效期
                dialogVisible: false,
                dialogImageUrl: '',

                // 提交数据
                basicForm: {
                    suppliersId: 0,                              // 供应商id
                    suppliersCode: '',                           // 供应商名称
                    suppliersName: '',						    // 供应商名称
                    officeCountry: null,					    // 办公地址-国家
                    officeProvince: null,					    // 办公地址-省份
                    officeCity: null,							// 办公地址-城市
                    officeDistrict: null,					    // 办公地址-区县
                    officeAddress: '',					        // 办公地址-详细地址

                    categoryIsBook: 0,                          // 是否是图书品类
                    categories: [],                             // 品类信息
                    status: 0,                                  // 审核状态

                    registeredCountry: null,					// 注册地址-国家
                    registeredProvince: null,					// 注册地址-省份
                    registeredCity: null,						// 注册地址-城市
                    registeredDistrict: null,					// 注册地址-区县
                    registeredAddress: '',					    // 注册地址-详细地址
                    registeredCapital: '',			            // 注册资金
                    businessLicenseCode: '',		            // 营业执照号
                    businessLicenseStartDate: null,		        // 营业执照有效起始时间
                    businessLicenseEndDate: null,		        // 营业执照有效结束时间

                    orgCode: '',								// 组织机构代码
                    personalCardType: 1,				        // 法定代表人证件类型

                    registeredName: '',					        // 注册登记名称
                    // 资质上传  执照类型 数据
                    licenseType: 1,
                    // 注册资金 类型
                    registeredCapitalType: 1,

                    // 资质上传  出版社经营许可证电子版 数据
                    publicationBusinessLicenseFile: [],
                    // 营业执照电子版
                    businessLicenseFile: [],
                    // 组织结构代码电子版
                    orgCodeFile: [],
                    // 税务登记证电子版
                    taxFile: [],
                    // 开户许可证电子版
                    accountOpeningPermitFile: [],
                    // 法定代表人身份证件电子版
                    personalCardFile: [],
                },

                oldBasicData:{

                },

                rules: {
                    suppliersName: [
                        {
                            required: true,
                            message: '请输入公司名称', trigger: 'blur'},
                        {max: 150, message: '最多输入30个字', trigger: 'blur'}
                    ],
                    officeProvince: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeCity: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeDistrict: [
                        {type: 'number', message: '请选择办公地址', trigger: 'change'},
                    ],
                    officeAddress: [
                        {required: true, message: '请填写完整办公地址', trigger: 'blur'},
                        {max: 50, message: '最多输入50个字', trigger: 'blur'}
                    ],
                    registeredName: [
                        {required: true, message: '请输入注册登记名称', trigger: 'blur'},
                    ],
                    registeredCountry: [
                        {required: true, type: 'number', message: '请选择注册登记地址', trigger: 'blur'},
                    ],
                    registeredCapital: [
                        {required: true, type: 'number', message: '请输入注册资金', trigger: 'blur'},
                    ],
                    registeredProvince: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredCity: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredDistrict: [
                        {type: 'number', message: '请选择注册登记地址', trigger: 'change'},
                    ],
                    registeredAddress: [
                        {required: true, message: '请输入详细注册地址', trigger: 'blur'},
                    ],
                    orgCode: [
                        {required: true, message: '请输入组织机构代码', trigger: 'blur'},
                    ]
                }
            }
        },

        methods: {
            getTimeStr (val) {
                if (val) {
                    var date = new Date(val);
                    var Y = date.getFullYear() + '-';
                    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                    var D = date.getDate() + ' ';
                    return Y + M + D;
                } else {
                    return "";
                }
            },

            fetch () {
                var that = this;
                var recordId = this.recordId;
                var suppliersId = 0;
                if (this.suppliersId) {
                    suppliersId = this.suppliersId;
                }
                if (recordId && recordId > 0) {
                    recordId = this.recordId;
                } else {
                    recordId = 0;
                }

                $.ajax({
                    url: '/suppliers/supplier/qualification/find',
                    method: 'get',
                    data: {
                        suppliersId: suppliersId,
                        recordId: recordId
                    },
                    success: function (result) {
                        if (!result.code) {
                            var data = result.data.lastest;
                            that.basicForm = data;
                            that.suppliersId = data.suppliersId;
                            that.basicForm.suppliersId = data.suppliersId;
                            that.basicForm.suppliersCode = data.suppliersCode;
                            that.basicForm.suppliersName = data.suppliersName;

                            //that.basicForm.officeCountry = data.officeCountry;
                            //that.basicForm.officeProvince = data.officeProvince;
                            //that.basicForm.officeCity = data.officeCity;
                            //that.basicForm.officeDistrict = data.officeDistrict;
                            that.basicForm.officeAddress = data.officeAddress;

                            that.basicForm.categoryIsBook = data.categoryIsBook;
                            that.basicForm.categoryNotBook = data.categoryNotBook;
                            if (that.basicForm.categoryIsBook == 1 && that.basicForm.categoryNotBook == 1) {
                                that.categoryType = ["1","2"]
                            } else if (that.basicForm.categoryIsBook == 1 && that.basicForm.categoryNotBook == 0) {
                                that.categoryType = ["1"]
                            } else if (that.basicForm.categoryIsBook == 0 && that.basicForm.categoryNotBook == 1) {
                                that.categoryType = ["2"]
                            }

                            if(that.basicForm.categoryIsBook == 1) {
                                that.isBook = true;
                            }

                            that.basicForm.categories = data.categories;
                            that.basicForm.status = data.status;

                            //that.basicForm.registeredCountry = data.registeredCountry;
                            //that.basicForm.registeredProvince = data.registeredProvince;
                            //that.basicForm.registeredCity = data.registeredCity;
                            //that.basicForm.registeredDistrict = data.registeredDistrict;
                            that.basicForm.registeredAddress = data.registeredAddress;

                            that.basicForm.officeCountryName = data.officeCountryName;
                            that.basicForm.officeProvinceName = data.officeProvinceName;
                            that.basicForm.officeCityName = data.officeCityName;
                            that.basicForm.officeDistrictName = data.officeDistrictName;
                            that.basicForm.registeredCountryName = data.registeredCountryName;
                            that.basicForm.registeredProvinceName = data.registeredProvinceName;
                            that.basicForm.registeredCityName = data.registeredCityName;
                            that.basicForm.registeredDistrictName = data.registeredDistrictName;

                            that.basicForm.registeredCapital = data.registeredCapital;
                            that.basicForm.businessLicenseCode = data.businessLicenseCode;
                            that.basicForm.orgCode = data.orgCode;
                            that.basicForm.personalCardType = data.personalCardType;
                            that.basicForm.registeredName = data.registeredName;
                            that.basicForm.licenseType = data.licenseType;
                            that.basicForm.registeredCapitalType = data.registeredCapitalType;

                            that.basicForm.publicationBusinessLicenseFile = that.fileTrans(data.publicationBusinessLicenseFile);
                            that.basicForm.businessLicenseFile = that.fileTrans(data.businessLicenseFile);
                            that.basicForm.orgCodeFile = that.fileTrans(data.orgCodeFile);
                            that.basicForm.taxFile = that.fileTrans(data.taxFile);
                            that.basicForm.accountOpeningPermitFile = that.fileTrans(data.accountOpeningPermitFile);
                            that.basicForm.personalCardFile = that.fileTrans(data.personalCardFile);

                            // 执照有效期
                            if (data.businessLicenseStartDate && data.businessLicenseEndDate) {
                                var stime = data.businessLicenseStartDate;
                                var etime = data.businessLicenseEndDate;
                                that.businessLicenseDate = [stime, etime];
                                that.basicForm.businessLicenseStartDate = data.businessLicenseStartDate;
                                that.basicForm.businessLicenseEndDate = data.businessLicenseEndDate;
                            }

                            // 快照数据
                            var snapshot = result.data.snapshot;
                            that.oldBasicData = result.data.snapshot;
                            if (snapshot) {
                                that.oldBasicData.publicationBusinessLicenseFile = that.fileTrans(snapshot.publicationBusinessLicenseFile);
                                that.oldBasicData.businessLicenseFile = that.fileTrans(snapshot.businessLicenseFile);
                                that.oldBasicData.orgCodeFile = that.fileTrans(snapshot.orgCodeFile);
                                that.oldBasicData.taxFile = that.fileTrans(snapshot.taxFile);
                                that.oldBasicData.accountOpeningPermitFile = that.fileTrans(snapshot.accountOpeningPermitFile);
                                that.oldBasicData.personalCardFile = that.fileTrans(snapshot.personalCardFile);
                                // 执照有效期
                                if (snapshot.businessLicenseStartDate && snapshot.businessLicenseEndDate) {
                                    that.oldBasicData.businessLicenseStartDate = snapshot.businessLicenseStartDate;
                                    that.oldBasicData.businessLicenseEndDate = snapshot.businessLicenseEndDate;
                                }
                            } else {
                                that.oldBasicData = {};
                            }
                            // that.getOfficeProvince();
                        } else if (result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            initControl(suppliersId,recordId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/control',
                    data: {
                        suppliersId: suppliersId,
                        type: 1,
                        recordId: recordId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.control = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 转化图片 格式[{url}]
            fileTrans(fileUrl){
                var array = [];
                if (fileUrl) {
                    var files = fileUrl.split(',');
                    for(var i=0;i<files.length;i++) {
                        var file = {};
                        file.url = files[i];
                        array.push(file);
                    }
                }
                return array;
            },

            // [] 图片转化成字符串
            fileTransToString(files) {
                var fileStr = "";
                if(files) {
                    for(var i =0; i < files.length; i++) {
                        if(files[i].url){
                            if(i!=0) {
                                fileStr += ",";
                            }
                            fileStr += files[i].url;
                        }
                    }
                }
                return fileStr;
            },

            // 预览图片
            previewPic (e) {
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            // 预览图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
                $(".el-upload-list__item").css('margin-bottom', "10px");
            },

            // 出版社经营许可证
            handlePublicationLicense(response, file) {
                if (!response.code) {
                    this.basicForm.publicationBusinessLicenseFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 营业执照
            handleBusinessLicense(response, file) {
                if (!response.code) {
                    this.basicForm.businessLicenseFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 组织机构代码
            handleOrgCode(response, file) {
                if (!response.code) {
                    this.basicForm.orgCodeFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 税务登记证
            handleTaxFile(response, file) {
                if (!response.code) {
                    this.basicForm.taxFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 开户许可证
            handleAccountOpeningPermit(response, file) {
                if (!response.code) {
                    this.basicForm.accountOpeningPermitFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 法定代表人身份证件
            handlePersonalCard(response, file) {
                if (!response.code) {
                    this.basicForm.personalCardFile = this.fileTrans(response.data);
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 出版社经营许可证
            removePublicationLicense () {
                this.basicForm.publicationBusinessLicenseFile = [];
            },

            // 经营许可证
            removeBusinessLicense () {
                this.basicForm.businessLicenseFile = [];
            },

            // 组织机构代码
            removeOrgCode () {
                this.basicForm.orgCodeFile = [];
            },

            // 税务登记证
            removeTaxFile () {
                this.basicForm.taxFile = [];
            },

            // 开户许可证
            removeAccountOpeningPermit () {
                this.basicForm.accountOpeningPermitFile = [];
            },

            // 法定代表人身份证件
            removePersonalCard () {
                this.basicForm.personalCardFile = [];
            },

            // 校验图片格式大小
            beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
                const isLt1M = file.size / 1024 / 1024 < 1;
                if (!isJPG) {
                    this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
                    return isJPG;
                }
                if (!isLt1M) {
                    this.$message.error('上传图片大小不能超过 1MB!');
                    return isLt1M;
                }
            },

            // 请求办公地址一级地址
            getAddress () {
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '1',
                        regionId: ''
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.countryList = result.data.list;
                        } else {
                             that.$message({
                               showClose: true,
                               message: result.msg,
                               type: 'error'
                             });
                        }
                    }
                })
            },

            // 请求办公地址二级地址
            getOfficeProvince () {
                var that = this;
                var regionId = this.basicForm.officeCountry;
                if (this.officeProvinceInit) {
                    this.basicForm.officeProvince = null;
                    this.basicForm.officeCity = null;
                    this.basicForm.officeDistrict = null;
                }
                if (regionId == 1) {
                    this.isForeign = false;
                } else {
                    this.isForeign = true;
                }
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '2',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.provinceList = result.data.list;
                            that.officeProvinceInit = true;
                        }
                    }
                })
            },

            // 请求办公地址三级地址
            getOfficeCity () {
                if(this.officeCityInit){
                    this.basicForm.officeCity = null;
                    this.basicForm.officeDistrict = null;
                }
                var that = this;
                var regionId = this.basicForm.officeProvince;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '3',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
                            console.log(result.data)
                            that.cityList = result.data.list;
                            that.officeCityInit = true;
                        }
                    }
                })
            },

            // 请求办公地址四级地址
            getOfficeDistrict () {
                if(this.officeDistrictInit){
                    this.basicForm.officeDistrict = null;
                }
                var that = this;
                var regionId = this.basicForm.officeCity;
                $.get({
                    url: '/suppliers/supplierSettled/findAddress',
                    data: {
                        type: '4',
                        regionId: regionId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.districtList = result.data.list;
                            that.officeDistrictInit=true;
                        }
                    }
                })
            },

            // 请求 注册省份列表
            getRegisteredProvince () {
                var that = this;
                var value = this.basicForm.registeredCountry;
                if(this.registeredProvinceInit){
                    this.basicForm.registeredProvince = null;
                    this.basicForm.registeredCity = null;
                    this.basicForm.registeredDistrict = null;
                }
                if (value == 1) {
                    this.isRegisteredForeign = false;
                    if(this.basicForm.licenseType==3){
                        this.basicForm.licenseType = 1;
                    }
                } else if (value && value != 1) {
                    this.isRegisteredForeign = true;
                    this.basicForm.licenseType = 3;
                }
                if (value == 1) {
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '2',
                            regionId: '1'
                        },
                        success: function (result) {
                            if (!result.code) {
                                that.registeredProvinceList = result.data.list;
                                that.registeredProvinceInit = true;
                            }
                        }
                    })
                } else {
                    this.registeredProvinceList = [];
                }
            },

            // 请求 注册城市列表
            getRegisteredCity () {
                var value = this.basicForm.registeredProvince;
                var that = this;
                if (this.registeredCityInit){
                    this.basicForm.registeredCity = null;
                    this.basicForm.registeredDistrict = null;
                }
                if (value) {
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '3',
                            regionId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                that.registeredCityList = result.data.list;
                                that.registeredCityInit = true;
                            }
                        }
                    })
                } else {
                    this.registeredCityList = [];
                }
            },

            // 请求 注册区县列表
            getRegisteredDistrict () {
                var value = this.basicForm.registeredCity;
                var that = this;
                if(this.registeredDistrictInit){
                    this.basicForm.registeredDistrict = null;
                }
                if (value) {
                    $.get({
                        url: '/suppliers/supplierSettled/findAddress',
                        data: {
                            type: '4',
                            regionId: value
                        },
                        success: function (result) {
                            if (!result.code) {
                                that.registeredDistrictList = result.data.list;
                                that.registeredDistrictInit = true;
                            }
                        }
                    })
                } else {
                    this.registeredDistrictList = [];
                }
            },

            // 执照类型变化
            licenseChange (val) {
                if (val == 2 || val == 3) {
                    this.isOneCertificate = false;
                } else {
                    this.isOneCertificate = true;
                }
            },

            // 返回
            returnPage(){
                var backType = this.$route.query.backType;
                if(this.control.loginType == 1 && backType && backType==1){
                    this.$router.push({
                        path:'/supplier_info?suppliersId='+this.basicForm.suppliersId+"&isStep=1"
                    })
                }else {
                    window.close();
                }
            },

            // 暂存
            saveForm() {
                var that = this;
                // var id = that.recordId;
                var Data = {};
                Data = JSON.parse(JSON.stringify(this.basicForm));
                // 处理图片
                Data.publicationBusinessLicenseFile = that.fileTransToString(this.basicForm.publicationBusinessLicenseFile);
                Data.businessLicenseFile = that.fileTransToString(this.basicForm.businessLicenseFile);
                Data.orgCodeFile = that.fileTransToString(this.basicForm.orgCodeFile);
                Data.taxFile = that.fileTransToString(this.basicForm.taxFile);
                Data.accountOpeningPermitFile = that.fileTransToString(this.basicForm.accountOpeningPermitFile);
                Data.personalCardFile = that.fileTransToString(this.basicForm.personalCardFile);

                if (Data.registeredCountry == 1) {
                    // 执照有效期
                    if(that.businessLicenseDate){
                        var startTime = that.businessLicenseDate[0];
                        var endTime = that.businessLicenseDate[1];
                        Data.businessLicenseStartDate = new Date(startTime).getTime();
                        Data.businessLicenseEndDate = new Date(endTime).getTime();
                    } else {
                        that.$message.error('请选择执照有效期');
                        return;
                    }
                }

                var categoryType = that.categoryType;
                if (categoryType) {
                    var categoryIsBook = 0;
                    var categoryNotBook = 0;
                    if (categoryType.indexOf("2") !== -1) {
                        this.basicForm.categoryNotBook = 1;
                    } else {
                        this.basicForm.categoryNotBook = 0;
                    }
                    if (categoryType.indexOf("1") !== -1) {
                        this.basicForm.categoryIsBook = 1;
                        this.isBook = true;
                    } else {
                        this.basicForm.categoryIsBook = 0;
                        this.isBook = false;
                    }
                }

                /*Data.categoryType = that.categoryType;
                if (that.categoryType) {
                    Data.categoryIsBook = 0;
                    Data.categoryNotBook = 0;
                    var num = that.categoryType.length;
                    for (var i = 0; i < num; i++) {
                        if (that.categoryType[i] == 1) {
                            Data.categoryIsBook = 1;
                        } else if (that.categoryType[i] == 2) {
                            Data.categoryNotBook = 1;
                        }
                    }
                }*/

                // 是否为图书
                /*if (this.isBook) {
                    Data.categoryIsBook = 1;
                } else {
                    Data.categoryIsBook = 0;
                }*/

                // 主键id
                Data.id = that.recordId;

                $.ajax({
                    url: '/suppliers/supplier/qualification/save',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            that.$message({
                                message: '成功保存草稿',
                                type: 'success'
                            });
                            that.recordId = result.data.id;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            // 提交校验
            checkSubmit(formName) {

                var that = this;
                if (this.basicForm.officeCountry == 1) {
                    if (!this.basicForm.officeProvince || !this.basicForm.officeCity || !this.basicForm.officeDistrict) {
                        this.$message.error('请选择办公地址');
                        return false;
                    }
                }

                if (this.basicForm.registeredCountry == 1) {
                    if (!this.basicForm.registeredProvince || !this.basicForm.registeredCity || !this.basicForm.registeredDistrict) {
                        this.$message.error('请选择注册地址');
                        return false;
                    }
                }

                if (this.categoryType.length == 0) {
                    this.$message.error("请选择品类合作类型");
                    return;
                }

                var categoryType = that.categoryType;
                var categoryIsBook = 0;
                var categoryNotBook = 0;
                if (categoryType.indexOf("2") !== -1) {
                    this.basicForm.categoryNotBook = 1;
                } else {
                    this.basicForm.categoryNotBook = 0;
                }
                if (categoryType.indexOf("1") !== -1) {
                    this.basicForm.categoryIsBook = 1;
                    this.isBook = true;
                } else {
                    this.basicForm.categoryIsBook = 0;
                    this.isBook = false;
                }

                /*Data.categoryType = that.categoryType;
                if (Data.categoryType) {
                    Data.categoryIsBook = 0;
                    Data.categoryNotBook = 0;
                    var num = that.categoryType.length;
                    if (num > 2) {
                        Data.categoryIsBook = categoryType[0];
                        Data.categoryNotBook = categoryType[1];
                    }
                    if (Data.categoryIsBook == 0 && Data.categoryNotBook == 0) {
                        this.$message.error("请选择品类合作类型");
                        return;
                    }
                } else {
                    this.$message.error("请选择品类合作类型");
                    return;
                }*/

                if (this.basicForm.categoryIsBook == 1) {
                    if (this.basicForm.publicationBusinessLicenseFile.length == 0) {
                        this.$message.error('请上传出版社经营许可证电子版');
                        return false;
                    }
                }

                if (this.basicForm.registeredCountry == 1) {
                    // 执照有效期
                    if(that.businessLicenseDate){

                    } else {
                        that.$message.error('请选择执照有效期');
                        return false;
                    }
                }

                if (this.basicForm.businessLicenseFile.length == 0 ||
                    this.basicForm.accountOpeningPermitFile.length == 0 ||
                    this.basicForm.personalCardFile.length == 0) {
                    this.$message.error('请上传相关资质图片');
                    return false;
                }

                if (this.basicForm.registeredCapital == 0) {
                    this.$message.error('注册资金不能为0');
                    return false;
                }

                if (this.basicForm.licenseType == 1) {
                    if(!this.basicForm.orgCode){
                        this.$message.error('请填写组织机构代码');
                        return false;
                    }
                }

                if (this.basicForm.registeredCountry == 1) {
                    if (!this.businessLicenseDate) {
                        this.$message.error('请选择执照有效期');
                        return false;
                    }
                }
                return true;
            },

            confirmSubmit(formName) {
                var that = this;
                if (!this.checkSubmit(formName)) {
                    return false;
                }
                this.$refs[formName].validate((valid) => {
                    console.log('when submit quanlication, validation result is ' + valid);
                    if (valid) {
                        that.$prompt('请输入详细修改原因', '修改原因', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputValidator: function(val){return (val==null || val.trim().length<1) ? false:true},
                            inputErrorMessage: '请输入详细修改原因'
                        }).then(({ value }) => {
                            that.submitForm(formName, value);
                        }).catch(() => {
                            that.$message({
                                type: 'info',
                                message: '已取消修改'
                            });
                        });
                    }
                })
            },

            // 提交履历
            submitForm(formName, remark) {
                var that = this;
                var id = that.recordId;
                var suppliersId = that.suppliersId;
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        var Data = {};
                        Data = JSON.parse(JSON.stringify(this.basicForm));
                        Data.publicationBusinessLicenseFile = that.fileTransToString(this.basicForm.publicationBusinessLicenseFile);
                        Data.businessLicenseFile = that.fileTransToString(this.basicForm.businessLicenseFile);
                        Data.orgCodeFile = that.fileTransToString(this.basicForm.orgCodeFile);
                        Data.taxFile = that.fileTransToString(this.basicForm.taxFile);
                        Data.accountOpeningPermitFile = that.fileTransToString(this.basicForm.accountOpeningPermitFile);
                        Data.personalCardFile = that.fileTransToString(this.basicForm.personalCardFile);
                        Data.remark = remark;
                        if (Data.registeredCountry == 1) {
                            // 执照有效期
                            if(that.businessLicenseDate){
                                var startTime = this.businessLicenseDate[0];
                                var endTime = this.businessLicenseDate[1];
                                Data.businessLicenseStartDate = new Date(startTime).getTime();
                                Data.businessLicenseEndDate = new Date(endTime).getTime();
                            } else {
                                that.$message.error('请选择执照有效期');
                                return;
                            }
                        }

                        if (this.basicForm.officeCountry == 1) {
                            if (!this.basicForm.officeProvince || !this.basicForm.officeCity || !this.basicForm.officeDistrict) {
                                this.$message.error('请选择办公地址');
                                return;
                            }
                        }
                        if (this.basicForm.registeredCountry == 1) {
                            if (!this.basicForm.registeredProvince || !this.basicForm.registeredCity || !this.basicForm.registeredDistrict) {
                                this.$message.error('请选择注册地址');
                                return;
                            }
                        }

                        if (this.basicForm.businessLicenseFile.length == 0 ||
                            this.basicForm.accountOpeningPermitFile.length == 0 ||
                            this.basicForm.personalCardFile.length == 0) {
                            this.$message.error('请上传相关资质图片');
                            return;
                        }

                        if (Data.registeredCapital == 0) {
                            this.$message.error('注册资金不能为0');
                            return;
                        }

                        if (Data.licenseType == 1) {
                            if(!Data.orgCode){
                                this.$message.error('请填写组织机构代码');
                                return;
                            }
                        }

                        if (Data.registeredCountry == 1) {
                            if (!this.businessLicenseDate) {
                                this.$message.error('请选择执照有效期');
                                return;
                            }
                        }

                        // 是否为图书
                        if (this.isBook) {
                            Data.categoryIsBook = 1;
                        } else {
                            Data.categoryIsBook = 0;
                        }

                        // 主键id
                        Data.id = that.recordId;

                        $.ajax({
                            url: '/suppliers/supplier/qualification/submit',
                            data: JSON.stringify(Data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (!result.code) {
                                    // 后台成功 改变路由
                                    that.$router.push({
                                        path:'/supplier_info?suppliersId=' + that.suppliersId
                                    })
                                } else {
                                    that.$message({
                                        showClose: true,
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },

            // 审核
            auditForm(type){//0:通过 1:驳回
                var that = this;
                var Data = {};
                if(type == 1){
                    this.$prompt('请输入审核驳回原因', '审核驳回', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator: function(val){return (val==null || val.trim().length<1) ? false:true},
                        inputErrorMessage: '请输入审核驳回原因'
                    }).then(({ value }) => {
                        Data.recordId = that.recordId;
                        Data.suppliersId = that.suppliersId;
                        Data.type = 2;
                        Data.reason = value;
                        $.ajax({
                            url: '/suppliers/supplier/qualification/audit',
                            data: JSON.stringify(Data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '驳回成功',
                                        type: 'success'
                                    });
//                                    //刷新父页面，关闭当前页面
//                                    if(window.opener) {
//                                        window.opener.location.reload();
//                                    }
                                    window.close();
                                } else {
                                    that.showErrorMsg(result.msg, '审核失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消审核'
                        });
                    });
                } else {  //审核通过
                    this.$prompt('请输入审核备注', '审核备注', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(({ value }) => {
                        Data.recordId = that.recordId;
                        Data.suppliersId = that.suppliersId;
                        Data.type = 1;
                        Data.reason = value;
                        $.ajax({
                            url: '/suppliers/supplier/qualification/audit',
                            data: JSON.stringify(Data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '审核成功',
                                        type: 'success'
                                    });
                                    //跳转
                                    setTimeout(function () {
                                        that.$router.push({
                                            path:'/supplier_info?suppliersId=' + that.suppliersId+'&isStep=1'
                                        })
                                    }, 500);
                                } else {
                                    that.showErrorMsg(result.msg, '审核失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消审核'
                        });
                    });
                }
            },
        },

        computed: {
            /*amount: function () {
                return 200 - this.basicForm.supplierIntro.length;
            }*/
        },

        mounted () {
            this.$nextTick(function () {
                var _this = this;
                var suppliersId = this.$route.query.suppliersId;
                var recordId = this.$route.query.recordId;
                this.suppliersId = suppliersId;
                this.recordId = recordId;
                this.getAddress();
                this.initControl(suppliersId, recordId);
                this.fetch();
            })
        },

        watch: {
            'basicForm.licenseType': function (val) {
                if (val == 2 || val == 3) {
                    this.basicForm.orgCode = '';
                    this.basicForm.orgCodeFile = [];
                    this.basicForm.taxFile = [];
                }
            },

            'basicForm.publicationBusinessLicenseFile': function (val) {
                if (val.length > 0) {
                    this.publicationBusinessLicenseShow = false;
                } else {
                    this.publicationBusinessLicenseShow = true;
                }
            },

            'basicForm.businessLicenseFile': function (val) {
                if (val.length > 0) {
                    this.businessLicenseShow = false;
                } else {
                    this.businessLicenseShow = true;
                }
            },

            'basicForm.orgCodeFile': function (val) {
                if (val.length > 0) {
                    this.orgCodeShow = false;
                } else {
                    this.orgCodeShow = true;
                }
            },

            'basicForm.taxFile': function (val) {
                if (val.length > 0) {
                    this.taxFileShow = false;
                } else {
                    this.taxFileShow = true;
                }
            },

            'basicForm.accountOpeningPermitFile': function (val) {
                if (val.length > 0) {
                    this.accountOpeningPermitShow = false;
                } else {
                    this.accountOpeningPermitShow = true;
                }
            },

            'basicForm.personalCardFile': function (val) {
                if (val.length > 0) {
                    this.personalCardShow = false;
                } else {
                    this.personalCardShow = true;
                }
            },

            'basicForm.registeredCountry': function (val) {
                if(val != 1) {
                    this.businessLicenseDate = null;
                }
            },

            'categoryType': function (arr) {
                var categoryIsBook = 0;
                var categoryNotBook = 0;
                if (arr.indexOf("2") !== -1) {
                    this.basicForm.categoryNotBook = 1;
                } else {
                    this.basicForm.categoryNotBook = 0;
                }
                if (arr.indexOf("1") !== -1) {
                    this.basicForm.categoryIsBook = 1;
                    this.isBook = true;
                } else {
                    this.basicForm.categoryIsBook = 0;
                    this.isBook = false;
                }
            }

        }

    }
</script>

<style type="text/css" lang="less" scoped>
    .audit_edit_pf {
        padding-left: 60px;
        padding-right: 60px;
    }

    .line {
        margin-left: 3%;
        display: inline-block;
        width: 91%;
        height: 1px;
        border-bottom: 1px dashed #999;
        vertical-align: middle;
    }

    .second_line {
        margin-left: 3%;
        display: inline-block;
        width: 87%;
        height: 1px;
        border-bottom: 1px dashed #666;
        vertical-align: middle;
    }

    .word_num {
        display: inline-block;
        vertical-align: bottom;
        margin-bottom: 22px;
        margin-left: 5px;
        color: #666;
    }

    .pic_tip {
        font-size: 12px;
        color: #ff4949;
        line-height: 1px;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
    }
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
        .edit_tab {
            display: inline-block;
            width: 262px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            color: #fff;
            background: #ff6c83;
        }
        .active_tab {
            background: #ff4a7d;
        }
        .tip_word {
            margin-top: 20px;
            width: 1048px;
            height: 160px;
            background: #f9f9f9;
            padding: 10px;
        }
    }
    .fixeds {
        position: absolute;
        top: 37px;
        left: 156px;
        background: #fff;
        z-index: 2;
        width: 148px;
        height: 148px;
    }
    .pic_min_skan {
        width: 60px;
        height: 60px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .rule_star {
        position: relative;
        left:-76px;
    }
    .rule_star90 {
        position: relative;
        left:-90px;
    }
    .rule_star2 {
        position: relative;
        left:-120px;
    }
    .rule_star3 {
        position: relative;
        left:-190px;
    }
    .rule_star4 {
        position: relative;
        left:-132px;
    }
    .rule_star5 {
        position: relative;
        left:-160px;
    }
    .rule_star6 {
        position: relative;
        left:-150px;
    }
    .rule_star200 {
        position: relative;
        left:-200px;
    }
    .rule_star105 {
        position: relative;
        left:-105px;
    }
    .ml_10 {
        margin-left: -10px;
    }
    .lh20 {
        line-height: 20px;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_skan_red {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 2px solid #ff4a7d;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .sign_address {

    }
</style>


// WEBPACK FOOTER //
// basicInfo.vue?4b32962c